import { FormProvider, useFormContext, useController } from 'react-hook-form';
import DareDropLogo1 from 'root/src/client/public/logo-daredrop0.png';
import { SATISFACTION_QUESTIONS } from 'root/src/shared/survey/survey.fixtures';
import { MAX_RECOMMEND_REASON_LENGTH } from 'root/src/client/v2/survey/constants/satisfactionSurvey.constants';
import { useSatisfactionSurveyForm } from 'root/src/client/v2/survey/hooks/useSatisfactionSurveyForm';
import { RadioField } from 'root/src/client/v2/form/components/RadioField';
import { TextField } from 'root/src/client/v2/common/components/form/TextField';
import { CheckboxField } from 'root/src/client/v2/form/components/CheckboxField';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
export const SatisfactionSurveyForm = ({ callback }) => {
    const { form, onFormSubmit } = useSatisfactionSurveyForm(callback);
    return (<FormProvider {...form}>
			<form className="flex flex-col justify-center items-left gap-8" onSubmit={onFormSubmit}>
				<Header />
				<div className="flex flex-col px-4 gap-8">
					{/* we could probably make a generic component that is rendered based on */}
					{/*  src/shared/survey/survey.fixtures.ts, but this is more readable. if editing */}
					{/*  survey becomes pain in the ass, we can change that */}
					<RecommendDareDropQuestion />
					<RecommendDareDropReason />
					<IssuesQuestion />
					<DropsRelevanceQuestion />
					<DiscoveryMethodQuestion />
				</div>
				<div className="flex justify-center">
					<ButtonNew disabled={form.formState.isSubmitting} type="submit" className="w-[164px] h-[53px]">SUBMIT
					</ButtonNew>
				</div>
			</form>
		</FormProvider>);
};
const Header = () => {
    return (<div className="flex flex-col justify-left items-center gap-1">
			<img {...DareDropLogo1} width={197} height={63} alt="logo"/>
			<span className="text-light-4">Survey</span>
			<hr className="h-[2px] w-[565px] border-light-4"/>
		</div>);
};
const RecommendDareDropQuestion = () => {
    const form = useFormContext();
    const { field, fieldState } = useController({
        name: 'recommendStrength',
        control: form.control,
    });
    const onChange = (value) => {
        form.setValue(field.name, value);
        form.clearErrors(field.name);
    };
    return (<div className="flex flex-col justify-center items-center gap-1">
			<span className="text-[9px] text-pink self-start">* Required</span>
			<span className="text-[15px] self-start">{SATISFACTION_QUESTIONS.RECOMMEND_STRENGTH.question}</span>
			<div className="w-[460px]">
				<RadioField options={SATISFACTION_QUESTIONS.RECOMMEND_STRENGTH.options.map(option => ({ label: option, value: option }))} id="satisfaction-survey-recommend" layout="horizontal" className="justify-between" onChange={onChange} value={field.value} error={Boolean(fieldState.error)}/>
			</div>
			<div className="flex justify-between w-[92%]">
				<span className="text-light-4 text-[12px]">Least Likely</span>
				<span className="text-light-4 text-[12px]">Most Likely</span>
			</div>
		</div>);
};
const RecommendDareDropReason = () => {
    var _a, _b;
    const form = useFormContext();
    const { field, fieldState } = useController({
        name: 'recommendReason',
        control: form.control,
    });
    const onChange = (value) => {
        form.setValue(field.name, value);
        form.clearErrors(field.name);
    };
    return (<div className="flex flex-col justify-center items-center gap-1">
			<span className="text-[9px] text-pink self-start">* Required</span>
			<span className="text-[15px] self-start">{SATISFACTION_QUESTIONS.RECOMMEND_REASON.question}</span>
			<div className="w-[460px]">
				<TextField placeholder="Enter your answer here" fullWidth multiline rows={4} onChange={e => onChange(e.target.value)} error={Boolean(fieldState.error)} value={field.value || ''} helperText={(_a = fieldState.error) === null || _a === void 0 ? void 0 : _a.message}/>
				<div className="flex">
					<span className={`mt-1 ml-auto ${fieldState.error ? 'text-[#f44336]' : ''}`}>{((_b = field.value) === null || _b === void 0 ? void 0 : _b.length) || 0} / {MAX_RECOMMEND_REASON_LENGTH}
					</span>
				</div>
			</div>
		</div>);
};
const IssuesQuestion = () => {
    const form = useFormContext();
    const { field } = useController({
        name: 'issues',
        control: form.control,
    });
    const onChange = (value) => {
        form.setValue(field.name, value);
    };
    return (<div className="flex flex-col justify-center items-center gap-1">
			<span className="text-[15px] self-start">{SATISFACTION_QUESTIONS.ISSUES.question}</span>
			<div className="w-[460px] mt-4">
				<CheckboxField options={SATISFACTION_QUESTIONS.ISSUES.options.map(option => ({ label: option, value: option }))} onChange={values => onChange(values)} value={field.value}/>
			</div>
		</div>);
};
const DropsRelevanceQuestion = () => {
    const form = useFormContext();
    const { field } = useController({
        name: 'dropRelevance',
        control: form.control,
    });
    const onChange = (value) => {
        form.setValue(field.name, value);
    };
    return (<div className="flex flex-col justify-center items-center gap-1">
			<span className="text-[15px] self-start">{SATISFACTION_QUESTIONS.DROP_RELEVANCE.question}</span>
			<div className="w-[460px] mt-1">
				<RadioField options={SATISFACTION_QUESTIONS.DROP_RELEVANCE.options.map(option => ({ label: option, value: option }))} id="drops-relevance" layout="vertical" onChange={value => onChange(value)} value={field.value}/>
			</div>
		</div>);
};
const DiscoveryMethodQuestion = () => {
    const form = useFormContext();
    const { field } = useController({
        name: 'discoveryMethod',
        control: form.control,
    });
    const onChange = (value) => {
        form.setValue(field.name, value);
    };
    return (<div className="flex flex-col justify-center items-center gap-1">
			<span className="text-[15px] self-start">{SATISFACTION_QUESTIONS.DISCOVERY_METHOD.question}</span>
			<div className="w-[460px] mt-1">
				<RadioField options={SATISFACTION_QUESTIONS.DISCOVERY_METHOD.options.map(option => ({ label: option, value: option }))} id="discovery-method" layout="vertical" onChange={value => onChange(value)} value={field.value}/>
			</div>
		</div>);
};
